export default __webpack_public_path__ + "static/media/tokens-gift.9ecee531.png";